'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var SectionAction = function SectionAction(props) {
	var alignRight = props.alignRight;

	var rest = _objectWithoutProperties(props, ['alignRight']);

	return _react2['default'].createElement('div', _extends({
		className: (0, _classnames2['default'])('SectionAction', {
			'SectionAction-alignRight': alignRight
		})
	}, rest));
};

SectionAction.propTypes = {
	alignRight: _propTypes2['default'].bool
};

module.exports = SectionAction;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/SectionAction.js
// module id = 331
// module chunks = 0